import { initializeApp, FirebaseOptions } from 'firebase/app';
import { connectAuthEmulator, getAuth, Auth, User as UserImpl } from "firebase/auth";
import { User } from '~/models/User';
import { currentEnv, Env, IsProduction } from '../config/Config';

const useEmulator = import.meta.env.VITE_USE_EMULATOR === 'true' || currentEnv === Env.local;
const emulatorLocation = import.meta.env.VITE_EMULATOR_LOCATION ?? "http://localhost:9011";

const getFirebaseConfig = (): FirebaseOptions => {
  if (currentEnv === Env.local) {
    // ローカル環境: civitusのFirebase Emulatorを使用
    return {
      apiKey: "fake-api-key",
      authDomain: "localhost",
      projectId: "civitus-local",
    }
  }
  if (IsProduction()) {
    return {
      apiKey: "AIzaSyAmj0Dnx9kRLLcfou79PRsyRHXlXHtu0kM",
      authDomain: "roxx-sirius-prod.firebaseapp.com",
      projectId: "roxx-sirius-prod",
      storageBucket: "roxx-sirius-prod.firebasestorage.app",
      messagingSenderId: "271307368557",
      appId: "1:271307368557:web:0db1bc5af880837745f764"
    }
  }
  return {
    apiKey: "AIzaSyDku9chafATXdovbCh3c19aP1ekAozmBl8",
    authDomain: "roxx-sirius-stg.firebaseapp.com",
    projectId: "roxx-sirius-stg",
    storageBucket: "roxx-sirius-stg.firebasestorage.app",
    messagingSenderId: "275820249149",
    appId: "1:275820249149:web:65e0d55b8f697566402a54"
  }
}

let client: Auth

export function getClient() {
  if (!client) {
    init()
  }
  return client
}


export function init(): void {
  const app = initializeApp(getFirebaseConfig());
  const auth = getAuth(app)
  auth.languageCode = 'ja';
  if (useEmulator) {
    connectAuthEmulator(auth, emulatorLocation);
  }
  client = auth
}

export async function getUser(): Promise<User | null> {
  const auth = getClient()
  await auth.authStateReady()
  const user = auth.currentUser
  if (!user) {
    return null
  }
  return createUser(user)
}

export async function createUser(user: UserImpl): Promise<User> {
  const newUser = new User(user);
  return newUser
}
